import React, { Component } from 'react'
import './drone.scss'
import { Link } from 'react-scroll'
import Contact from '../Contact/Contact.js'
import FAQ from '../FAQ/FAQ.js'
import GalleryModal from '../GalleryModal/GalleryModal.js'
import VideoImage from '../VideoImage/VideoImage.js'
import {Helmet} from "react-helmet"
import ReactGA from 'react-ga'
import gal1 from './gal-1.jpg'
import gal2 from './gal-2.jpg'
import gal3 from './gal-3.jpg'
import gal4 from './gal-4.jpg'
import gal5 from './gal-5.jpg'
import gal6 from './gal-6.jpg'
import gal7 from './gal-7.jpg'
import gal8 from './gal-8.jpg'
import gal9 from './gal-9.jpg'
import mavicMini from './mavic_mini.jpg'
import mavic2 from './mavic2.jpg'
import content from './content.jpg'
import pfco from './profile.jpg'
import timelapse from './timelapse.jpg'
import videoEditing from './video_editing.jpg'
import timelapseVideo from './timelapse.mp4'
import carl from './carl.jpg'
import poster from './poster.jpg'
import colorGrading from './color-grading.mp4'
import introVideo from './intro.mp4'
import introVideoMobile from './intro_mb.mp4'

class Drone extends Component {

    constructor(props) {
        super(props);
        this.state = { showGalleryModal: false, isMobile: window.innerWidth <= 600 };

        ReactGA.initialize('UA-135520207-1');
        ReactGA.event({
            category: 'User',
            action: 'Drone loaded'
        });
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    galleryImageClicked = index => {
        this.setState({ showGalleryModal: true, photoIndex: index });
    }

    closeModal = () => {
        this.setState({ showGalleryModal: false });
    }

    resize = () => {
        this.setState({isMobile: window.innerWidth <= 600});
    }

    render() {
        const isMobile = this.state.isMobile;
        const images = [ gal1, gal2, gal3, gal4, gal5, gal6, gal7, gal8, gal9 ];

        return (
            <div>
                <Helmet>
                    <title>ERC Drone Productions</title>
                    <meta name="description" content="ERC Drone Productions offers professional aerial photography and videography for a wide range of services. We are authorised by the CAA and fully insured.  Part of ERC Solutions." />
                    <meta name="keywords" content="erc solutions, erc drone productions, web design, aerial photography, drone services, pfco, commercial drone services" />
                </Helmet>
                <section id="drone">
                  <div className="video-wrapper">
                    <video autoPlay muted loop poster={poster} playsInline>
                        <source src={ isMobile ? introVideoMobile : introVideo } type="video/mp4" />
                    </video>
                    <div className="bg-mask"></div>
                    <div id="title-wrapper">
                      <div className="video-text">
                        Aerial photography & Drone services
                      </div>
                      <div className="video-subtext">
                        Capture your imagination from above
                      </div>
                      <Link
                          activeClass="active"
                          to="services"
                          spy={true}
                          smooth={true}
                          offset={-56}
                          duration={800}
                          className="btn-learn-more">
                          See More
                      </Link>
                    </div>
                  </div>
                </section>

                <section id="services">
                  <div className="container standard-section">
                    <h5 className="text-center mb-5">Services</h5>
                    <div className="row service-icons">
                      <div className="col-lg-3 mb-4 mb-lg-0">
                        <div className="icon-wrapper">
                          <i className="fas fa-camera-retro mb-3"></i>
                          <div className="icon-title">Ground &amp; aerial photography</div>
                          <div className="description-text">Our footage will be of the highest quality using the latest, state of the art technology.  Capture anything from a panorama, a promotional video or simply an aerial shot, we provide you with stunning, high detailed media to suit your requirements.</div>
                        </div>
                      </div>
                      <div className="col-lg-3 mb-4 mb-lg-0">
                        <div className="icon-wrapper">
                          <i className="fas fa-crop-alt mb-3"></i>
                          <div className="icon-title">Photo editing &amp; colour grading</div>
                          <div className="description-text">Post production photographic editing to ensure that the photographs we take are delivered in the highest quality to suit your look.</div>
                        </div>
                      </div>
                      <div className="col-lg-3 mb-4 mb-lg-0">
                        <div className="icon-wrapper">
                          <i className="fas fa-film mb-3"></i>
                          <div className="icon-title">Content creation</div>
                          <div className="description-text">We create cinematic films, brought to life by our expert imagination and video editing, allowing you to share them on social media, your website or to use however you wish.</div>
                        </div>
                      </div>
                      <div className="col-lg-3">
                        <div className="icon-wrapper">
                          <i className="fas fa-paper-plane mb-3"></i>
                          <div className="icon-title">Qualified drone pilot</div>
                          <div className="description-text">CAA approved PfCO drone pilot, providing well planned, safe flights with the required liability insurance.</div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <section id="dark" className="p-0">
                      <div className="cover-wrapper">
                          <div className="img-fluid bg-cover"></div>
                      </div>
                  </section>

                  <section className="standard-section">
                      <div id="cinematic-footage" className="service-section">
                          <div className="container">
                              <div className="row">
                                <div className="col-lg-6">
                                  <div className="services-wrapper">
                                    <h3 className="text-center mb-4">Cinematic footage</h3>
                                    <div className="content-text mb-4 mb-lg-0">Create a promotion video for your business or organisation and show it off in 4k resolution, with expert editing and capture to really set your business apart from others.</div>
                                  </div>
                                </div>
                                <div className="col-lg-6">
                                    <VideoImage youtubeId='UDYM3IWXFr8' imageSrc={content} alt="Cinematic Footage"/>
                                </div>
                            </div>
                          </div>
                      </div>

                      <div id="hyperlapse" className="service-section">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-6 order-2 order-lg-1">
                            <VideoImage videoSrc={timelapseVideo} imageSrc={timelapse} alt="Timelapse"/>
                            </div>
                            <div className="col-lg-6 order-1 order-lg-2">
                              <div className="services-wrapper">
                                <h3 className="text-center mb-4">Time lapse</h3>
                                <div className="content-text mb-4 mb-lg-0">Show off your project progress, organisation or local surroundings with a high definition time lapse capturing all the movements over your specified time range.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="color" className="service-section">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="services-wrapper">
                                <h3 className="text-center mb-4">Colour grading</h3>
                                <div className="content-text mb-4 mb-lg-0">We use the latest photographic and video editing tools to make your media stand out from the rest, to the highest quality.  Colors will be edited to suit your theme, shoot a black and white, a picturesque view or a panoramic in stunning high detail colour.</div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                                <VideoImage videoSrc={colorGrading} imageSrc={videoEditing} alt="Colour Grading"/>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div id="pfco" className="service-section">
                        <div className="container">
                          <div className="row">
                            <div className="col-lg-6 order-2 order-lg-1">
                                <img id="pfco-image" className="img-fluid" src={pfco} alt="Permission for Commercial Operation" />
                            </div>
                            <div className="col-lg-6 pt-4 order-1 order-lg-2">
                              <div className="services-wrapper">
                                <h3 className="text-center mb-4">PfCO Qualified</h3>
                                <div className="content-text mb-4 mb-lg-0">We have been granted with a Permission for Commercial Operations (PfCO) by the Civil Aviation Authority (CAA), allowing us to operate commercial drone operations.  All flights are well planned, risk assessed and conform to the CAA regulations to ensure that your requirements are met in the safest possible way.</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                  </section>
                </section>

                <section id="team" className="standard-section">
                    <div className="img bg-cover"></div>
                    <div className="container text-center">
                        <div className="row justify-content-center">
                            <div className="col-lg-10">
                                <h5 className="mb-5">Our Team</h5>
                                <img className="mb-3" src={carl} alt="Carl Evans"/>
                                <h4>Carl Evans</h4>
                                <div className="mb-3">Founder</div>
                                <div className="desc">
                                    Carl is a CAA approved Drone/UAV Pilot.
                                    <p>For the past 15 years, Carl has worked in the IT industry using the latest innovative technologies with both the public and private sector, transferring these experiences into the business.</p>
                                    <p></p><p>A keen sportsman, Carl previously played Welsh league football.  He now spends his weekends either on the golf course trying to improve his handicap or taking in the Welsh scenery with his family.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="equipment" className="standard-section">
                  <div className="container">
                    <h5 className="text-center mb-5">Equipment</h5>
                    <div className="row">
                        <div className="col-lg-6 p-3 text-center">
                            <div className="alt-title text-center mb-4">
                                Mavic 2 Pro
                            </div>
                            <img className="img-fluid mb-4" src={mavic2}  alt="Mavic 2 Pro" />
                            <table className="table table-borderless equipment-table">
                                <tbody>
                                    <tr>
                                        <td className="enhanced-no">
                                            4k
                                        </td>
                                        <td className="enhanced-no">
                                            20
                                        </td>
                                        <td className="enhanced-no">
                                            45
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="description-text">
                                            Ultra HD Video
                                        </td>
                                        <td className="description-text">
                                            Megapixel Camera
                                        </td>
                                        <td className="description-text">
                                            mph
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="col-lg-6 p-3 text-center">
                            <div className="alt-title description-text text-center mb-4">
                                Mavic Mini
                            </div>
                            <img className="img-fluid mb-4" src={mavicMini} alt="Mavic Mini"/>
                            <table className="table table-borderless equipment-table">
                                <tbody>
                                    <tr>
                                        <td className="enhanced-no">
                                            2.7k
                                        </td>
                                        <td className="enhanced-no">
                                            12
                                        </td>
                                        <td className="enhanced-no">
                                            249g
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="description-text">
                                            HD Video
                                        </td>
                                        <td className="description-text">
                                            Megapixel Camera
                                        </td>
                                        <td className="description-text">
                                            Less than 250 grams
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                  </div>
                </section>

                <section id="gallery" className="standard-section mb-0">
                  <div className="img bg-cover"></div>
                  <div className="container">
                    <h5 className="text-center mb-5">Gallery</h5>
                      <div className="section-header-separator text-center mb-4"></div>
                      <div id="images">

                          <div className="swiper-container">

                              <div className="swiper-wrapper mb-5">

                                  <div className="swiper-slide">
                                      <div className="row no-gutters">
                                        <div className="col-md-4 px-0 px-md-1 px-lg-2 mb-4 mb-md-2 mb-lg-0 text-center text-right-md">
                                          <img id="img1" src={gal1} className="img-fluid mb-md-1 mb-lg-2" onClick={this.galleryImageClicked.bind(this, 0)} alt="Gallery One"/>
                                          <img id="img2" src={gal2} className="img-fluid my-4 my-md-1 my-lg-2" onClick={this.galleryImageClicked.bind(this, 1)} alt="Gallery Two"/>
                                          <img id="img3" src={gal3} className="img-fluid mt-md-1 mt-lg-2" onClick={this.galleryImageClicked.bind(this, 2)} alt="Gallery Three"/>
                                        </div>
                                        <div className="col-md-4 px-0 px-md-1 px-lg-2 mb-4 mb-md-2 mb-lg-0 text-center text-right-md">
                                          <img id="img4" src={gal4} className="img-fluid mb-md-1 mb-lg-2" onClick={this.galleryImageClicked.bind(this, 3)} alt="Gallery Four"/>
                                          <img id="img5" src={gal5} className="img-fluid my-4 my-md-1 my-lg-2" onClick={this.galleryImageClicked.bind(this, 4)} alt="Gallery Five"/>
                                          <img id="img6" src={gal6} className="img-fluid mt-md-1 mt-lg-2" onClick={this.galleryImageClicked.bind(this, 5)} alt="Gallery Six"/>
                                        </div>
                                        <div className="col-md-4 px-0 px-md-1 px-lg-2  text-center text-right-md">
                                          <img id="img7" src={gal7} className="img-fluid mb-md-1 mb-lg-2" onClick={this.galleryImageClicked.bind(this, 6)} alt="Gallery Seven"/>
                                          <img id="img8" src={gal8} className="img-fluid my-4 my-md-1 my-lg-2" onClick={this.galleryImageClicked.bind(this, 7)} alt="Gallery Eight"/>
                                          <img id="img9" src={gal9} className="img-fluid mt-md-1 mt-lg-2" onClick={this.galleryImageClicked.bind(this, 8)} alt="Gallery Nine"/>
                                        </div>
                                      </div>
                                      </div>
                                  </div>
                              </div>

                              <div className="swiper-pagination"></div>
                      </div>
                  </div>
                </section>

                {this.state.showGalleryModal && (<GalleryModal images={images} photoIndex={this.state.photoIndex} closeModal={this.closeModal} />)}

                <section id="faq" className="standard-section">
                    <div className="container text-center">
                        <h5 className="text-center mb-5">FAQ</h5>
                        <FAQ key={1} faClass="fas fa-car-crash faq-icon" question="What level of insurance do you hold?" answer="We hold the required EC785/2004 compliant insurance with a standard £1 million liability cover that can be increased depending on your needs." />
                        <FAQ key={2} faClass="fas fa-wallet faq-icon" question="How much do you charge?" answer="Each piece of work/project is priced individually and based on your needs.  We can meet up with you, capture your requirements and give you a specific quote depending on what you want and the complexity of the work." />
                        <FAQ key={3} faClass="fas fa-graduation-cap faq-icon" question="What drone qualifications do you have?" answer="Alongside hobby flight hours capturing all different types of footage, we have taken the PfCO training course with a CAA approved National Qualified Entity (NQE).  This qualification includes both a theory and practical examination ensuring that all pilot competencies are met to carry out commercial operations." />
                        <FAQ key={4} faClass="fas fa-building faq-icon" question="How close can you fly to people/buildings?" answer={["We fly to the PfCO regulations, which allows us with standard permissions to fly to 30 metres of uninvolved people, vessels and structures on take off/landing and a 50 metre ‘bubble’ whilst in operation.  For open-air assemblies of more than 1,000 people, a 150 metre distance must be applied. More details can be found ", <a key={41} id='pfco-link' href='https://www.caa.co.uk/Commercial-industry/Aircraft/Unmanned-aircraft/Small-drones/Regulations-relating-to-the-commercial-use-of-small-drones/' target='_blank'>here</a>, "."]} />
                        <FAQ key={5} faClass="fas fa-book faq-icon" question="What is the process once our requirements have been agreed?" answer="Before the operation can take place, we pre-plan the whole flight, ensuring that we conform to regulations, get any necessary clearance and make sure that all the risks involved in the flight area are captured and assessed.  There are a number of factors that are assessed such as airspace regulations, uninvolved people, weather conditions and location of shoot.  These play a vital part in this process, we just need to make sure that the flight can take place in a safe controlled environment with minimised risk." />
                        <FAQ key={6} faClass="fas fa-sun faq-icon" question="What is the process on the day of the operation?" answer="On the day of operation, we will carry out an on site assessment, including equipment checks to ensure everything is in place so that the flight can take place safely.  Emergency procedures will be put in place, to ensure that in the unlikely hood that something was to go wrong, then all the risks are minimised." />
                        <FAQ key={7} faClass="fas fa-moon faq-icon" question="Can you operate at night time?" answer="Yes, extra checks will be required to operate at night including a daytime site survey that needs to take place before hand." />
                    </div>
                </section>
                <Contact facebook="ercdroneproductions" instagram="ercdroneproductions" />
            </div>
        );
    }
}

export default Drone;



// WEBPACK FOOTER //
// ./src/components/Drone/Drone.js